import { CandidateStatus, OnsiteInterviewStatus, OnsiteInterviewStatusMapper } from '../enums';
import {
  ICandidateOnsiteInterviewEntity,
  IGetCandidateOnsiteInterviewListApiResponse,
  IGetCandidateOnsiteInterviewListResult,
} from '../types';

const toGetCandidateOnsiteInterviewListResult = (
  response: IGetCandidateOnsiteInterviewListApiResponse,
): IGetCandidateOnsiteInterviewListResult => {
  const initialGroups = Object.values(OnsiteInterviewStatus).reduce(
    (acc, status) => ({ ...acc, [status]: [] }),
    {} as Record<OnsiteInterviewStatus, string[]>,
  );

  const data: string[] = [];
  const maps: Record<string, ICandidateOnsiteInterviewEntity> = {};
  const groups = response.data.reduce((acc, item) => {
    const entity: ICandidateOnsiteInterviewEntity = {
      onsiteInterviewId: item.onsiteInterviewId,
      onsiteInterviewStatus: OnsiteInterviewStatusMapper.fromJobStatus(item.onsiteInterviewStatus),
      appliedAt: item.appliedAt,
      jobDatetime: item.jobDatetime,
      jobDatetimeEnd: item.jobDatetimeEnd,
      profession: item.profession,
      specialty: item.specialty,
      rate: item.rate,
      candidatesAppliedCount: item.candidatesAppliedCount,
    };

    data.push(item.onsiteInterviewId);
    maps[item.onsiteInterviewId] = entity;

    const status = entity.onsiteInterviewStatus;
    acc[status] = [...(acc[status] ?? []), item.onsiteInterviewId];

    return acc;
  }, initialGroups);

  return {
    data,
    maps,
    groups,
    officeStatus: response.officeStatus as CandidateStatus,
    hasScheduledInterview: groups[OnsiteInterviewStatus.Scheduled].length > 0,
    hasCompletedInterviews: groups[OnsiteInterviewStatus.Completed].length > 0,
  };
};

export const CandidateOnsiteInterviewAdapters = {
  toGetCandidateOnsiteInterviewListResult,
};
